<template>
  <b-tabs vertical nav-wrapper-class="nav-vertical nav-act" class="tabs-users">
    <!-- general tab -->
    <b-tab active>
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{$t('MY_ACCOUNT.Tab_Account')}}</span>
      </template>

      <account-setting-general />
    </b-tab>
    <!--/ general tab -->
    <!-- change password tab -->
    <b-tab>
      <template #title>
        <feather-icon icon="LockIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{$t('MY_ACCOUNT.Tab_Change_Password')}}</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->
    <!-- Shortchut tab -->
    <b-tab>
      <template #title>
        <feather-icon icon="SlidersIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{$t('MY_ACCOUNT.Tab_Shortcut')}}</span>
      </template>

      <account-setting-shortcut />
    </b-tab>
    <!--/ Shortchut tab -->

    <!-- Config tab -->
    <b-tab>
      <template #title>
        <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{$t('MY_ACCOUNT.Tab_Config')}}</span>
      </template>

      <account-setting-config />
    </b-tab>
    <!--/ Config tab -->

    <!-- info -->
    <!-- <b-tab>

      <template #title>
        <feather-icon
          icon="InfoIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Information</span>
      </template>

      <account-setting-information
        v-if="options.info"
        :information-data="options.info"
      />
    </b-tab> -->

    <!-- social links -->
    <!-- <b-tab>

      <template #title>
        <feather-icon
          icon="LinkIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Social</span>
      </template>

      <account-setting-social
        v-if="options.social"
        :social-data="options.social"
      />
    </b-tab> -->

    <!-- notification -->
    <!-- <b-tab>

      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Notifications</span>
      </template>

      <account-setting-notification
        v-if="options.notification"
        :notification-data="options.notification"
      />
    </b-tab> -->
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import AccountSettingGeneral from "./AccountSettingGeneral.vue";
import AccountSettingPassword from "./AccountSettingPassword.vue";
import AccountSettingShortcut from "./AccountSettingShortcut.vue";
import AccountSettingConfig from "./AccountSettingConfig.vue";
// import AccountSettingInformation from './AccountSettingInformation.vue'
// import AccountSettingSocial from './AccountSettingSocial.vue'
// import AccountSettingNotification from './AccountSettingNotification.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingShortcut,
    AccountSettingConfig,
  },
  data() {
    return {
      options: {},
    };
  },
};
</script>
<style>
.modal-footer {
  display: none;
}
</style>
